import {OrigemProduto} from "./nfce/OrigemProduto";
import {TipoDeTributacaoIPI} from "./nfce/TipoDeTributacaoIPI";
import {SeloDeControleIPI} from "./nfce/SeloDeControleIPI";
import {EnumTipoDeCalculo} from "./EnumTipoDeCalculo";

export class ProdutoConfigFiscal {
  id: number
  origem: OrigemProduto
  ncm: string //8 caracteres
  gtin: string //14 caracteres
  cest: string //7 caracteres
  unidade: string //2 caracteres
  producaoPropria: boolean

  //campos ipi
  tipoDeTributacaoIPI: TipoDeTributacaoIPI;
  codigoEnquadramentoIPI: string
  cnpjProdutor: string
  tipoCalculoIPI: EnumTipoDeCalculo;

  //calculo por aliquota
  aliquotaIPI: number

  //calculo por valor
  valorPorUnidadeIPI: number

  seloDeControleIPI: SeloDeControleIPI
  quantidadeSeloDeControleIPI: number

  ipiCompoeBaseCalculoICMS: boolean
  aliquotaAtributosAproximados: number
  informacoesAdicionais: string
  constructor() {
  }
}
